import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Quiz from "../components/Quiz";
import logo from "../assets/logo.webp";

const Home = () => {
  return (
    <div className="App">
      <Header />

      {/* Hero with big logo image */}
      <section className="hero" id="top">
        <div className="hero-bg-orb orb-1" />
        <div className="hero-bg-orb orb-2" />

        <p className="hero-eyebrow">Home Staging Emozionale</p>

        <img src={logo} alt="Francesca Spinazzola" className="hero-logo-img" />
      </section>

      {/* Interactive quiz */}
      <Quiz />

      {/* Skip the test -> go to the tools page (with the tabs) */}
      <div className="skip-test">
        <Link to="/prodotti" className="skip-test-btn">
          <span>Salta il test e vai agli strumenti</span>
          <ArrowRight size={16} strokeWidth={1.8} />
        </Link>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
